import { Query } from 'domain/models/query'
import INotificationRepository from 'domain/interfaces/repositories/INotificationRepository'

export const readGetAllNotificationsQuery = (
  repository: INotificationRepository,
  query?: Query,
) => {
  return repository.getAllNotifications(query)
}
